module.exports = __webpack_public_path__ + "img/card-service-purchase-request.2b178d3a.svg";